import { Component, OnInit } from '@angular/core';
import { MatDialogConfig, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { FreecodemodalComponent } from '../../freeticket/freecodemodal/freecodemodal.component';
import { PassagerService } from '../../../core/services/passager/passager.service';
import { MatTableDataSource } from '@angular/material/table';
import { PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';

@Component({
  selector: 'app-cardmodal',
  templateUrl: './cardmodal.component.html',
  styleUrls: ['./cardmodal.component.css']
})
export class CardmodalComponent implements OnInit {

  dataSource = new MatTableDataSource();
  displayedColumns = ['id', 'ticket', 'passager', 'phone', 'bus', 'tarif', 'siege',
    'destination',
    'category',
    'createdby',
    'date',
    'datecreation',
    'action',
  ];

  card: any;
  ispopup: boolean = false;
  userprivileges: any;
  sort: any;

  constructor(private passengerService:PassagerService, private dialog: MatDialog, private dialogref: MatDialogRef<CardmodalComponent>) {
    this.userprivileges = localStorage.getItem('authority');
    this.userprivileges = JSON.parse(this.userprivileges);
    this.sort = new MatSort();
   }

  ngOnInit(): void {
    this.getcardContain();
  }

  getcardContain(): any {
    let cardcontain: any =  localStorage.getItem('card');
    cardcontain = JSON.parse(cardcontain);
    this.card = cardcontain;
    this.dataSource = new MatTableDataSource(this.card);
    this.dataSource.sort = this.sort;
    // console.log(this.card);
  }

  close(): any{
    this.dialogref.close();
  }

  empty(): void{
    localStorage.removeItem('card');
    this.card = [];
    this.close();
  }

  remove(data: any):any{
    var index = this.card.indexOf(data);
      // console.log('out ', data);
      if (index > -1) {
        this.card.splice(index, 1);
        if(this.card.length>0){
          localStorage.setItem('card', this.card);
        }
        if(this.card.length==0){
          localStorage.removeItem('card');
        }
        this.dataSource = new MatTableDataSource(this.card);
        this.dataSource.sort = this.sort;
        // this.courriermultipleselections.splice(index, 1);
      }
  }

  generatecode(): any {
    this.ispopup = true;
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    // dialogConfig.position={
    //   right:'110px',
    // };
    dialogConfig.data = {};
    const dialogref = this.dialog.open(FreecodemodalComponent, {
      width: '600px', height: 'auto', autoFocus: true, disableClose: dialogConfig.disableClose, data: {
        ticket: this.card,
        freeticket : true
      }
    });

    dialogref.afterClosed().subscribe((result: any) => {
      this.ispopup = false;
      if (result != false){
        for (let i = 0; i < this.card.length; i++) {
          this.passengerService.updateTicketStatusAfterCount(this.card[i].idpv, result).subscribe((response: any) => {
            // console.log(response);
          });
        }
        this.card = [];
        localStorage.removeItem('card');
      }
    });
  }

  nextPage(event: PageEvent): any {}


}
